module.exports = __webpack_public_path__ + "static/media/clipboard.2970597a.svg";